import styled from 'styled-components';

const themedInfobox = styled.div`
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.colorPrimary};
  border-left: 8px solid ${(props) => props.theme.colorPrimary};
  position: relative;
`;

export const StyleInfobox = styled(themedInfobox)`
  ${(props) =>
    props.variant === 'neutral' && {
    }}
  ${(props) =>
    props.variant === 'success' && {
    }}
  ${(props) =>
    props.variant === 'fail' && {
    }}
`;

export default StyleInfobox;
